import { APP_ROUTES } from 'shared/constants/navigation';
import { TokenService } from 'lib/apis/TokenService';
import { setVendorConnectSessionCookies } from 'shared/utils/vendorConnectSessionCookies';

const RequireAnonymous = (context) => {
    const params = new URLSearchParams(window.location.search);
    const redirectUrl = params?.get('red_url') || null;

    if (context.store.isAuthed) {
        // If Vendor Connect sent us here with red_url, set the Vendor Connect cookies and bounce back.
        if (redirectUrl) {
            const tokenService = TokenService();

            // Fire-and-forget: route guards are synchronous.
            Promise.resolve()
                .then(async () => {
                    const accessToken = await tokenService.getOrRefreshAccessToken();
                    const idToken = tokenService.getIdToken();
                    const refreshToken = tokenService.getRefreshToken();

                    setVendorConnectSessionCookies({
                        idToken,
                        accessToken,
                        refreshToken,
                        businessName:
                            // Prefer store/webstore name; fallback to vendor name if needed.
                            context?.store?.webstore?.WebstoreName ||
                            context?.store?.vendor?.name ||
                            '',
                    });

                    if (window.location.href !== redirectUrl) {
                        window.location.href = redirectUrl;
                    }
                })
                .catch(() => {
                    // ignore; fall through to landing
                });

            return APP_ROUTES.landing;
        }

        return APP_ROUTES.landing;
    }

    return 'next';
};

export default RequireAnonymous;
